import { axiosDefaults, get, patch, post, toQueryString } from '../axios'
import { z } from 'zod'
import { user, UserQuery } from './user'
import { RegisterInput } from './input/register-input'
import { ResetInput } from './input/reset-input'
import { AuthenticateInput } from './input/authenticate-input'
import axios from 'axios'
import { loginResponse } from './login'
import { ForgotInput } from './input/forgot-input'
import { SubscribeInput } from './input/subscribe-input'
import { storeToken, storeUser as authStoreUser } from '../auth'
import { paginated } from '../zod/pagination'
import { StoreInput } from './input/store-input'
import { UpdateInput } from './input/update-input'

export function blockUser(userId: string) {
    return patch(user, `/users/${userId}/block`)
}
export function fetchUsers({ query }: { query?: UserQuery } = {}) {
    return get(paginated(user), '/users' + `?${toQueryString(query || {})}`)
}
export function resendVerification(userId: string) {
    return post(z.string(), `/users/${userId}/resend-verification`, {})
}
export function fetchUser(userId: string) {
    return get(user, `/users/${userId}`)
}
export function storeUser(input: StoreInput) {
    return post(user, '/users', input)
}
export function unblockUser(userId: string) {
    return patch(user, `/users/${userId}/unblock`)
}
export function updateUser(userId: string, input: UpdateInput) {
    return patch(user, `/users/${userId}`, input)
}

export const forgotPassword = (input: ForgotInput) => {
    return post(z.string(), '/forgot', input)
}

export const resetPassword = (input: ResetInput) => {
    return post(z.string(), '/reset', input)
}

export const subscribe = (input: SubscribeInput) => {
    return post(
        z
            .object({
                intent: z.enum(['payment', 'card_setup']),
                clientSecret: z.string(),
            })
            .or(
                z.object({
                    subscribed: z.boolean(),
                })
            ),
        '/subscribe',
        input
    )
}

export const register = (input: RegisterInput) => {
    return post(loginResponse, `/register`, input)
}

export const fetchMe = () => {
    return get(user, '/me').then((user) => {
        authStoreUser(user)

        return user
    })
}

export const verify = (email: string, signature: string, expires: number) => {
    return patch(z.string(), `/verify/${email}?expires=${expires}&signature=${signature}`)
}

export const updateActiveCompany = (companyId: string) => {
    return patch(z.string(), `/active-company/${companyId}`)
}

export const login = (data: AuthenticateInput) => {
    // A fresh login must not refresh or attach a previous browser session.
    return axios
        .create(axiosDefaults)
        .post('/login', data)
        .then((response) => loginResponse.parse(response.data))
}

export const impersonate = (userId: string) => {
    return post(loginResponse, `/users/${userId}/impersonate`, {})
}

export const refresh = (token: string) => {
    return axios
        .create(axiosDefaults)
        .get('/refresh', {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then((response) => loginResponse.parse(response.data))
        .then((response) => {
            storeToken(response[0], 'access')
            storeToken(response[1], 'refresh')

            return response
        })
}

export const fetchRegistrationSecurity = () =>
    get(z.object({ turnstileSiteKey: z.string().nullable() }), '/registration/security')
